// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"_89566c9","container":"_f61456d","option":"_76e81d8","odds":"_524e952","activeOption":"_c94754b","toggle":"_5f0c6ec","startingPrice":"_f66a0ba","oddsChanged":"_7f89184"};